import React from 'react';
import SharedDetails from '../../Components/SharedDetails/SharedDetails';

const columns = [
  { title: 'Name', field: 'Name' },
  { title: 'Email', field: 'Email' },
  { title: 'User Type', field: 'UserType' },
];

const csvHeaders = [
  { label: 'Name', key: 'Name' },
  { label: 'Email', key: 'Email' },
  { label: 'User Type', key: 'UserType' },
];

const UserDetails = () => (
  <SharedDetails
    columns={columns}
    csvFilename="user-details.csv"
    csvHeaders={csvHeaders}
    emptyMessage="No user records found."
    pagedEndpoint="/api/get/user/paged"
    errorMessage="Unable to load users. Please try again."
    loadingMessage="Loading users..."
    title="User Details"
  />
);

export { UserDetails };
export default UserDetails;
